import React, { useState, useEffect, useRef } from "react";
import {
	Box,
	Divider,
	Typography,
	Button,
	Card,
	TextField,
	InputAdornment,
	Select,
	MenuItem,
	OutlinedInput,
	FormControl,
	Paper,
	Breadcrumbs,
	FormHelperText,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";

import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import CardComponent from "../../components/cards/Card";
import AddIcon from "../../assets/images/add_2.svg";
import SearchIcon from "../../assets/images/search.svg";
import ReusableModal from "../../components/ReusableModal/ReusableModal";
import { Label } from "@fluentui/react";
import DataTable from "../../components/dataTable/DataTable";
import { columnList, columnsFileslist } from "../../constants/common";
import { Link } from "react-router-dom";
import {
	createCW,
	DeleteCWrkspace,
	DeleteFiles,
	exportDocuments,
	getContractList,
	getDocuments,
	retryContract,
	updateComments,
	updateFileType,
	uploadFiles,
	triggerWorkspaceProcessing,
} from "../../api";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../store/loaderSlice";
import { showSnackbar } from "../../store/snackBarSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { setWorkspaceInStrore } from "../../store/commonSlice";
import { Scenario, listScenarios } from "../../api/scenarios";
import GenerateScenariosModal from "../../components/modals/GenerateScenariosModal";
import RunScenarioModal from "../../components/modals/RunScenarioModal";
import ShareModal from "../../components/modals/ShareModal";
import EditableFileType from "../../components/EditableFileType/EditableFileType";


const ContractWC = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const location = useLocation();
	const [open, setOpen] = useState(false);
	const [uploadType, setUploadType] = useState("Manual");
	const [workspaceName, setWorkspaceName] = useState("");
	const [comments, setComments] = useState("");
	const [workspaceID, setWorkspaceID] = useState("");
	const [workspaceIndexId, setWorkspaceIndexId] = useState<number | undefined>(undefined);

	const [files, setFiles] = useState<File[]>([]);
	const [uploadStatus, setUploadStatus] = useState<{ [key: string]: string }>(
		{}
	);
	const [isUploading, setIsUploading] = useState(false);
	const [wrkspaceCards, setWrkSpaceCards] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(30);
	const [viewFiles, setViewFiles] = useState(false);
	const [filesCount, setFilesCount] = useState(0);
	const [tableData, setTableData] = useState<any[]>([]);
	const [error, setError] = useState("");
	const [search, setSearch] = useState("");
	const [openEditModal, setOpenEditModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [openDeleteFileModal, setOpenDeleteFileModal] = useState(false);
	const [openRunScenarioModal, setOpenRunScenarioModal] = useState(false);
	const [openGenerateScenariosModal, setOpenGenerateScenariosModal] = useState(false);
	const [openShareModal, setOpenShareModal] = useState(false);
	const [selectedFileId, setSelectedFileId] = useState<string | null>(null);
	const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
	const [actionType, setActionType] = useState<string | null>(null);
	const [scenarios, setScenarios] = useState<Scenario[]>([]);

	// State to track if file type is being updated
	const [updatingFileType, setUpdatingFileType] = useState(false);
	// Removed selectedScenario state as it's now handled in RunScenarioModal component
	// Removed runResponse state as it's now handled in RunScenarioModal component
	// Removed generateResponse state as it's now handled in GenerateScenariosModal component
	const dispatch = useDispatch();
	const fileInputref = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (files && files.length) {
			handleUploadFiles();
		}
	}, [files.length]);

	// Handle direct navigation to file list view via URL query parameter
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const workspaceParam = params.get('workspace');
		
		if (workspaceParam) {
			// Set the workspace ID and fetch workspace details
			setWorkspaceID(workspaceParam);
			setViewFiles(true);
			
			// Fetch workspace name from the contract list
			const fetchWorkspaceName = async () => {
				try {
					dispatch(showLoader());
					const resp = await getContractList('', '');
					if (resp && resp.success) {
						const workspace = resp.data.contracts.find(
							(contract: any) => contract.contract_id.toString() === workspaceParam
						);
						if (workspace) {
							setWorkspaceName(workspace.contract_workspace);
						}
					}
				} catch (error) {
					console.error('Error fetching workspace details:', error);
				} finally {
					dispatch(hideLoader());
				}
			};
			
			fetchWorkspaceName();
		}
	}, [location.search, dispatch]);

	useEffect(() => {
		let pollingInterval: any;

		const fetchData = async () => {
			if (viewFiles) {
				const response = await getDocumentsPerWrkspace();
				if (response?.data?.all_completed) {
					clearInterval(pollingInterval); // Stop polling when all_completed is true
				}
			} else {
				const response = await getContractLists();
				if (response?.data?.all_completed) {
					clearInterval(pollingInterval); // Stop polling when all_completed is true
				}
			}
		};

		// Start polling
		pollingInterval = setInterval(() => {
			fetchData();
		}, 15000); 

		if (viewFiles) {
			getDocumentsPerWrkspace();
			
		} else {
			getContractLists();
		}

		// Clean up interval on unmount or when dependencies change
		return () => clearInterval(pollingInterval);
	}, [viewFiles,search,rowsPerPage,page]);

	const handleClose = () => {
		setOpen(false);
		setOpenFilesModal(false);
		setOpenEditModal(false)
		setFiles([]);
		setOpenDeleteModal(false)
		setError('');
		setOpenDeleteFileModal(false)
		setOpenRunScenarioModal(false);
		setOpenGenerateScenariosModal(false);
		setOpenShareModal(false);
		setSelectedFileId("");  
		setSelectedFileName("");  
		setActionType("");  
	};
	const handleDeleteClick = async (type:string,fileId: string,fileName:string) => {
		setSelectedFileId(fileId);  
		setSelectedFileName(fileName);  
		setActionType(type);  
		if(type === "delete"){
			setOpenDeleteFileModal(true);  
		}else{
			if (type === "download") {
				const resp:any = await exportDocuments(fileId);
			}
		}
		
	};

	// api to call contract lists
	const getContractLists = async () => {
		const resp = await getContractList(search, '');
		if (resp && resp.success) {
			setWrkSpaceCards(resp.data.contracts);
		} else {
			dispatch(
				showSnackbar({
					message: `${resp.message}`,
					severity: "error",
				}),
			);;
		}
		return resp;
	};

	const handleOpen = () => {
		setOpen(true);
		resettingConfig();
	};

	// Handle file selection
	const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const selectedFiles = event.target.files;
		if (selectedFiles && selectedFiles.length > 0) {
			// if workspaceID is not there means new CW creation.
			if (!workspaceID) await createDocumentWorkspace();
			
			setFiles(Array.from(selectedFiles)); 
			const initialStatus: { [key: string]: string } = {};
	
			Array.from(selectedFiles).forEach((file) => {
				initialStatus[file.name] = "Pending";
			});
	
			setUploadStatus(initialStatus);
			if (fileInputref?.current) {
				fileInputref.current.value = '';
			}
		}
	};
	

	// Handle file upload
	const handleUploadFiles = async () => {

		setIsUploading(true); // Set uploading to true to show progress
		const updatedStatus = { ...uploadStatus }; // Copy the current uploadStatus to modify it directly
		let hasSuccessfulUpload = false;

		for (const file of files) {
			// Mark the file as "Uploading" immediately
			updatedStatus[file.name] = "Uploading";

			// Set state with the new status
			// setUploadStatus({ ...updatedStatus });
			const formData = new FormData();
			formData.append("file", file);
			setUploadStatus((prev) => ({
				...prev,
				[file.name]: "Uploading",
			}));

			try {
				await uploadFiles(formData, workspaceID);
				await getContractLists();

				// const status = await mockApiUpload(file.name); // Wait for the mock API to return
				updatedStatus[file.name] = "Uploaded";
				setUploadStatus({ ...updatedStatus });
				hasSuccessfulUpload = true;
			} catch (error) {
				updatedStatus[file.name] = "Failed";
				setUploadStatus({ ...updatedStatus });
			}
		}

		// After all files are uploaded, trigger processing for the workspace
		if (hasSuccessfulUpload && workspaceID) {
			try {
				await triggerWorkspaceProcessing(workspaceID);
			} catch (error) {
				console.error("Failed to trigger workspace processing:", error);
				dispatch(
					showSnackbar({
						message: "Files uploaded but failed to start processing. Try refreshing the workspace.",
						severity: "warning",
					})
				);
			}
		}

		getDocumentsPerWrkspace();
		setIsUploading(false); // End uploading process
	};

	const handleUploads = async () => {
		setError("");
		if (!workspaceName) {
			setError("Required field");
			return;
		}
		openUploadModal();
	};

	const createDocumentWorkspace = async () => {
		const payload = {
			contract_workspace_name: workspaceName,
			comments: comments,
		};
		const val = await createCW(payload);
		if (!val.success) {
			setError(`${val.payload}`);
		}
		setWorkspaceID(val.data.contract_workspace_id);
	}

	const handleAddFile = () => {
		openUploadModal();
	}

	const openUploadModal = () => {
		document.getElementById("file-input")?.click();
	};

	const handleViewFiles = async (id: any, name: any, count: any) => {
		setWorkspaceID(id);
		setWorkspaceName(name);
		setViewFiles(true);
		// await getDocumentsPerWrkspace(id, name);
	};

	const handleBreadCrumb = () => {
		resettingConfig();
		setViewFiles(false);
	};

	const resettingConfig = () => {
		setWorkspaceID("");
		setError('')
		setComments('')
		setWorkspaceName("");
	};

	const getDocumentsPerWrkspace = async () => {
		const resp = await getDocuments(workspaceID,search,page + 1,rowsPerPage);
		setTableData(resp.data.files);
		setFilesCount(resp.data.files.length);
		const { total_items } = resp?.pagination;
		setTotalCount(total_items);
		return resp;
	};

	// Function to handle file type updates
	const handleFileTypeUpdate = async (fileId: string, newType: string) => {
		setUpdatingFileType(true);
		try {
			// Call the API to update the file type
			const response = await updateFileType(parseInt(fileId), newType);

			if (response.success) {
				// Update the local state with the new file type
				const updatedData = tableData.map((file: any) => {
					if (file.file_id === fileId) {
						return { ...file, file_type: newType };
					}
					return file;
				});
				setTableData(updatedData);

				// Show success message
				dispatch(
					showSnackbar({
						message: response.message || "File type updated successfully",
						severity: "success",
					}),
				);
			} else {
				// Show error message
				dispatch(
					showSnackbar({
						message: response.message || "Failed to update file type",
						severity: "error",
					}),
				);
			}
		} catch (error) {
			// Show error message
			dispatch(
				showSnackbar({
					message: `Failed to update file type: ${error}`,
					severity: "error",
				}),
			);
		} finally {
			setUpdatingFileType(false);
		}
	};
	
	const loadScenarios = async (contractId: number | null = null) => {
		try {
			// Get the numeric contract ID from the workspaceID
			const effectiveContractId = contractId !== null ? contractId : (workspaceID ? parseInt(workspaceID) : null);

			// Convert to array format required by listScenarios
			const contractIdArray = effectiveContractId !== null ? [effectiveContractId] : null;

			// Use the new INCLUDE_GENERIC filter to get both generic and contract-specific scenarios in one call
			const response = await listScenarios(1, 100, contractIdArray, "INCLUDE_GENERIC");

			// Sort scenarios by name for better usability
			const sortedScenarios = [...response.items].sort((a, b) => 
				a.scenario_name.localeCompare(b.scenario_name)
			);
			
			setScenarios(sortedScenarios);
		} catch (error) {
			dispatch(
				showSnackbar({
					message: `Failed to load scenarios: ${error}`,
					severity: "error",
				}),
			);
		}
	};

	// Removed handleRunScenario function as it's now handled in RunScenarioModal component

	// Removed handleGenerateScenarios function as it's now handled in GenerateScenariosModal component

	const handleActions = async (
		type: any,
		id: any,
		comments: string,
		workspaceName: string,
		indexId?: number
	) => {
		setWorkspaceID(id);
		setWorkspaceName(workspaceName);
		setWorkspaceIndexId(indexId);
		const payload = {
			contract_id : id,
			contract_worspace : workspaceName
		}
		if (type.id === "delete") {
			setOpenDeleteModal(true)
		} else if (type.id === "add") {
			addFiles();
		}else if( type.id === "update"){
			setOpenEditModal(true)
			setComments(comments)
		}else if(type.id === "insight"){
			dispatch(setWorkspaceInStrore(payload))
			navigate("/homepage/intelligence")
		}else if(type.id === "attributes"){
			dispatch(setWorkspaceInStrore(payload))
			navigate("/homepage/attributes")
		}else if(type.id === "run_scenario"){
			loadScenarios(parseInt(id));
			setOpenRunScenarioModal(true);
		}else if(type.id === "generate_scenarios"){
			setOpenGenerateScenariosModal(true);
		}else if(type.id === "share"){
			setOpenShareModal(true);
		}else if(type.id === "refresh"){
			try {
				dispatch(showLoader());
				const response = await retryContract(id);
				if (response && response.success) {
					dispatch(
						showSnackbar({
							message: "Contract refresh initiated successfully",
							severity: "success",
						})
					);
				} else {
					dispatch(
						showSnackbar({
							message: response?.payload || "Failed to refresh contract",
							severity: "error",
						})
					);
				}
			} catch (error) {
				console.error("Error refreshing contract:", error);
				dispatch(
					showSnackbar({
						message: "Failed to refresh contract",
						severity: "error",
					})
				);
			} finally {
				dispatch(hideLoader());
			}
		}
		await getContractLists();
	};

	const handleDelete = async () => {		
			const resp = await DeleteCWrkspace(workspaceID);
			if(!resp.success){
				dispatch(
					showSnackbar({
						message: `${resp.payload}`,
						severity: "error",
					}),
				);
				return
			}
			else {
				dispatch(
					showSnackbar({
						message:  `${resp.message}`,
						severity: "success",
					}),
				);
				resettingConfig();
				handleClose();
				await getContractLists();
			}
	
	}
	const handleDeleteFile = async () => {
		if(selectedFileId){
         if (actionType === "delete") {
			const resp = await DeleteFiles(selectedFileId);
			if (resp.success) {
				dispatch(
					showSnackbar({
						message:  `${resp.message}`,
						severity: "success",
					}),
				);
				await getDocumentsPerWrkspace();
				handleClose()
			} else {
				dispatch(
					showSnackbar({
						message: `${resp.payload}`,
						severity: "error",
					}),
				);
			}
		}
		
	}
	};
	const [openFilesModal, setOpenFilesModal] = useState(false);
	const addFiles = () => {
		// openUploadModal();
		setOpenFilesModal(true);
	};

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		const target = e.target as HTMLInputElement;
			setSearch(target.value);
	};

	const handleUpdateWoskpace = async () => {
		const payload = {
			contract_workspace_id: workspaceID,
			comments: comments,
		};
		console.log('handle Save',payload);
		await updateComments(payload);
		await getContractLists();
		resettingConfig();
		handleClose();
	}

	return (
		<Grid
			container
			sx={{ width: "100%", justifyContent: "center", height: "95vh" }}
		>
			<Grid
				sx={{
					flex: 1,
					mt: 8,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					background: "#fff",
					boxShadow:
						"0px 2px 4px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)",
					borderRadius: "8px",
					width: "100%",
				}}
			>
				<Grid
					container
					sx={{ width: "100%" }}
					justifyContent="space-between"
				>
					<Typography
						align="center"
						sx={{ fontSize: "1.5rem", px: 2, p: 1.5 }}
					>
						Document Management
					</Typography>
					<Divider sx={{ width: "100%" }} />
				</Grid>
				{!viewFiles ? (
					<>
						<Grid
							container
							sx={{ width: "100%", p: 1.5 }}
							justifyContent="space-between"
							alignItems="center"
						>
							<Typography
								align="center"
								variant="h1"
								sx={{ fontSize: "1.15rem" }}
							>
								Document Workspaces
							</Typography>
							<Box>
								<TextField
									value={search}
									variant="outlined"
									size="small"
									placeholder="Search"
									slotProps={{
										input: {
											startAdornment: (
												<InputAdornment position="start">
													<img
														src={SearchIcon}
														alt="Search"
													/>
												</InputAdornment>
											),
										},
									}}
									fullWidth
									onChange={handleSearch}
									sx={{ width: 500, height: 42 }}
								/>
							</Box>
						</Grid>
						<Grid
							justifyContent="flex-start"
							alignItems="center"
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: "row",
							}}
						>
							<Grid container spacing={2} sx={{ p: 1.5 }}>
								{/* Add New Workspace Card */}
								<Grid>
									<Card
										variant="outlined"
										sx={{
											height: "230px",
											width: "300px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											borderRadius: 2,
											border: 3,
											borderColor:
												theme.palette.secondary.main,
										}}
									>
											<Box textAlign="center">
												<IconButton
													size="large"
													color="primary"
													onClick={handleOpen}
												>
													<img
														src={AddIcon}
														alt="Add"
													/>
												</IconButton>
											<Typography
												variant="body2"
												sx={{ px: 8, pt: 1 }}
											>
												Click to create a new Document
												Workspace
											</Typography>
										</Box>
									</Card>
								</Grid>

								{/* Existing Workspace Cards */}
								{wrkspaceCards?.map((card: any) => (
									<Grid key={card.contract_id}>
										<CardComponent
											{...card}
											onClickCard={handleViewFiles}
											onActionClicked={handleActions}
										/>
									</Grid>
								))}
							</Grid>
						</Grid>
					</>
				) : (
					<>
						<Box sx={{ width: "100%", p: 2 }}>
							{/* Header Section */}
							<Grid
								container
								spacing={2}
								alignItems="center"
								sx={{ marginBottom: 2 }}
							>
							</Grid>
							{/* Breadcrumb */}
							<Grid
								container
								spacing={2}
								alignItems="center"
								sx={{ marginBottom: 2 }}
							>
								{/* Breadcrumbs */}
								<Grid>
									<Breadcrumbs
										separator=">"
										aria-label="breadcrumb"
									>
										<Typography
											color="secondary"
											sx={{
												cursor: "pointer",
											}}
											onClick={handleBreadCrumb}
										>
											Document Management 
										</Typography>
										<Typography color="textPrimary">
											{workspaceName} ({filesCount})
										</Typography>
									</Breadcrumbs>
								</Grid>
							</Grid>
							{/* Search Bar and Add Files Button */}
							<Grid
								display="flex"
								alignItems="center"
								justifyContent="space-between"
								sx={{ pb: 2 }}
							>
								<Grid>
									<TextField
										value={search}
										variant="outlined"
										size="small"
										placeholder="Search"
										slotProps={{
											input: {
												startAdornment: (
													<InputAdornment position="start">
														<img
															src={SearchIcon}
															alt="Search"
														/>
													</InputAdornment>
												),
											},
										}}
										fullWidth
										onChange={handleSearch}
										sx={{ width: 500, height: 42 }}
									/>
								</Grid>
								<Grid>
									<Button
										variant="outlined"
										sx={{ width: 150 }}
										onClick={addFiles}
									>
										Add Files
									</Button>
								</Grid>
							</Grid>

							{/* Table Section */}
							<Paper>
								<DataTable
									data={tableData}
									columns={columnList}
									page={page}
									totalCount={totalCount}
									setPage={setPage}
									rowsPerPage={rowsPerPage}
									setRowsPerPage={setRowsPerPage}
									onDelete={handleDeleteClick}
									onFileTypeUpdate={handleFileTypeUpdate}
								/>
							</Paper>
						</Box>
					</>
				)}
			</Grid>

			{/* dialog box */}
			<ReusableModal
				open={open}
				onClose={handleClose}
				title="Create Document Workspace"
				content={
					<Box>
							<Box>
								<Typography>Upload Type</Typography>
								<Select
									value={uploadType}
									onChange={(e) =>
										setUploadType(e.target.value)
									}
									displayEmpty
									disabled={files.length > 0}
									fullWidth
									sx={{ width: '250px' }}
								>
									<MenuItem value="" disabled>
										Select Upload Type
									</MenuItem>
									<MenuItem value="Manual">Manual</MenuItem>
									{/* <MenuItem value="Other">Other</MenuItem> */}
								</Select>
							</Box>

							{uploadType === "Manual" &&  (
								<Box sx={{mt:2}}>
								<FormControl
									sx={{ width: "800px" }}
									variant="outlined"
									error={!!error}
								>
									<Typography>
										Enter New Workspace Name
									</Typography>
									<Box sx={{mt:'2px'}}>
										<OutlinedInput
											id="workspace-name"
											aria-describedby="workspace-helper-text"
											style={{width: `100%`}}
											value={workspaceName}
											disabled={files.length > 0}
											onChange={(e) =>
												setWorkspaceName(e.target.value)
											}
											inputProps={{
												"aria-label": "Workspace Name",
											}}
											required
										/>
										{error && (
											<Box sx={{position:'absolute'}}>
												<FormHelperText id="workspace-helper-text">
												{error}
											</FormHelperText>
											</Box>
										)}
									</Box>
								</FormControl>
								</Box>
							)}

						{uploadType === "Manual" && (
							<>
								<Box sx={{mt:2}}>
									<FormControl
										sx={{ width: "800px" }}
										variant="outlined"
									>
										<Typography>Comments</Typography>
										<OutlinedInput
											id="comments"
											aria-describedby="comments-helper-text"
											value={comments}
											disabled={files.length > 0}
											onChange={(e) =>
												setComments(e.target.value)
											}
											inputProps={{
												"aria-label": "Comments",
											}}
										/>
									</FormControl>
								</Box>
							</>
						)}

						{files.length > 0 && (
							<div style={{ marginTop: "20px" }}>
								<Typography variant="h6">
									Total Files ({files.length})
								</Typography>
								{files && (
									<Paper>
										<DataTable
											data={files.map((file) => ({
												file_name: file.name,
												status:
													uploadStatus[file.name] ||
													"Pending",
											}))}
											columns={columnsFileslist}
											page={page}
											totalCount={files.length}
											setPage={setPage}
											rowsPerPage={rowsPerPage}
											setRowsPerPage={setRowsPerPage}
											showPagination={false}
										/>
									</Paper>
								)}
							</div>
						)}
					</Box>
				}
				actions={
					<>
					{files.length > 0 ? (
						<Button variant="contained" onClick={handleClose}>
						  Done
						</Button>
					  ) : (
						<>
						  <Button onClick={handleClose} color="secondary">
							Cancel
						  </Button>
						  <Button variant="contained" onClick={handleUploads}>
							Select Files
						  </Button>
						</>
					  )}
					  </>
				}
			/>
			{/* for add files only */}
			<ReusableModal
				open={openFilesModal}
				onClose={handleClose}
				title="Add Files"
				content={
					<Box>
						{files.length > 0 && (
							<div style={{ marginTop: "20px" }}>
								<Typography variant="h6">
									Total Files ({files.length})
								</Typography>
								{files && (
									<Paper>
										<DataTable
											data={files.map((file) => ({
												file_name: file.name,
												status:
													uploadStatus[file.name] ||
													"Pending",
											}))}
											columns={columnsFileslist}
											page={page}
											totalCount={files.length}
											setPage={setPage}
											rowsPerPage={rowsPerPage}
											setRowsPerPage={setRowsPerPage}
											showPagination={false}
										/>
									</Paper>
								)}
							</div>
						)}
					</Box>
				}
				actions={
					<>
					{files.length > 0 ? (
						<Button variant="contained" onClick={handleClose}>
						  Done
						</Button>
					  ) : (
						<>
						  <Button onClick={handleClose} color="secondary">
							Cancel
						  </Button>
						  <Button variant="contained" onClick={handleAddFile}>
							Select Files
						  </Button>
						</>
					  )}
					  </>
				}
			/>

			{/* for edit comments */}
			<ReusableModal
				open={openEditModal}
				onClose={handleClose}
				title="Edit"
				content={
					<Box>
							<Box>
								<Typography>Upload Type</Typography>
								<Select
									value={uploadType}
									onChange={(e) =>
										setUploadType(e.target.value)
									}
									displayEmpty
									disabled={openEditModal}
									fullWidth
									sx={{ width: '250px' }}
								>
									<MenuItem value="" disabled>
										Select Upload Type
									</MenuItem>
									<MenuItem value="Manual">Manual</MenuItem>
									{/* <MenuItem value="Other">Other</MenuItem> */}
								</Select>
							</Box>

							{uploadType === "Manual" && (
								<Box sx={{mt:2}}>
									<FormControl
									sx={{  width: "800px" }}
									variant="outlined"
									error={!!error}
								>
									<Typography>
										Workspace Name
									</Typography>
									<Box sx={{mt:'2px'}}>
										<OutlinedInput
											id="workspace-name"
											aria-describedby="workspace-helper-text"
											value={workspaceName}
											style={{width: '100%'}}
											disabled={openEditModal}
											onChange={(e) =>
												setWorkspaceName(e.target.value)
											}
											inputProps={{
												"aria-label": "Workspace Name",
											}}
											required
										/>
										{error && (
											<Box sx={{position:'absolute'}}>
												<FormHelperText id="workspace-helper-text">
												{error}
											</FormHelperText>
											</Box>
										)}
									</Box>
								</FormControl>
								</Box>
							)}

						{uploadType === "Manual" && (
							<>
								<Box sx={{mt:2}}>
									<FormControl
										sx={{ width: "800px" }}
										variant="outlined"
									>
										<Typography>Comments</Typography>
										<OutlinedInput
											id="comments"
											aria-describedby="comments-helper-text"
											value={comments}
											onChange={(e) =>
												setComments(e.target.value)
											}
											inputProps={{
												"aria-label": "Comments",
											}}
										/>
									</FormControl>
								</Box>
							</>
						)}
						
					</Box>
				}
				actions={
					<>
						  <Button onClick={handleClose} color="secondary">
							Cancel
						  </Button>
						  <Button variant="contained" onClick={handleUpdateWoskpace}>
							Save
						  </Button>
						</>
				}
			/>

			{/* delete confirmation */}

			<ReusableModal
				open={openDeleteModal}
				onClose={handleClose}
				title="Delete"
				content={
					<Box>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="flex-start"
						>
							<Box>
								<Typography>
									Are you sure you want to delete <strong>{workspaceName}</strong> ?
								</Typography>
							</Box>
						</Box>
					</Box>
				}
				actions={
					<>
						  <Button onClick={handleClose} color="secondary">
							Cancel
						  </Button>
						  <Button variant="contained" onClick={handleDelete}>
							Delete
						  </Button>
						</>
				}
			/>
						{/* delete file confirmation */}

						<ReusableModal
				open={openDeleteFileModal}
				onClose={handleClose}
				title="Delete"
				content={
					<Box>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="flex-start"
						>
							<Box>
								<Typography>
									Are you sure you want to delete <strong>{selectedFileName}</strong> ?
								</Typography>
							</Box>
						</Box>
					</Box>
				}
				actions={
					<>
						  <Button onClick={handleClose} color="secondary">
							Cancel
						  </Button>
						  <Button variant="contained" onClick={handleDeleteFile}>
							Delete
						  </Button>
						</>
				}
			/>
			{/* Run Scenario Modal */}
			<RunScenarioModal
				open={openRunScenarioModal}
				onClose={handleClose}
				workspaceID={workspaceID}
				workspaceName={workspaceName}
			/>

			{/* Generate Scenarios Modal */}
			<GenerateScenariosModal
				open={openGenerateScenariosModal}
				onClose={handleClose}
				workspaceID={workspaceID}
				workspaceName={workspaceName}
			/>

			{/* Share Modal */}
			<ShareModal
				open={openShareModal}
				onClose={handleClose}
				contractId={workspaceID}
				contractName={workspaceName}
				contractIndexId={workspaceIndexId}
			/>

			<input
				id="file-input"
				ref={fileInputref}
				type="file"
				accept=".pdf"
				multiple
				onChange={handleFileChange}
				style={{ display: "none" }}
			/>
		</Grid>
	);
};

export default ContractWC;
